<template>
  <card>
    <vue-element-loading
      :text="loading.text"
      spinner="bar-fade-scale"
      :color="loading.color"
      :active="loading.active"
      :is-full-screen="false"
    />
    <div slot="header">
      <h4 class="title">Nuevo Ambiente</h4>
    </div>
    <div>
      <form id="edit_form" @submit.prevent="validate">
        <div class="row">
          <div class="col-md-6">
            <fg-input
              type="text"
              label="Nombre"
              placeholder="Nombre del Ambiente"
              v-model="ambiente.name"
              v-validate="modelValidations.name"
              name="name"
              :error="getError('name')"
            />
          </div>
          <div class="col-md-6">
            <fg-input
              type="text"
              label="Identificador"
              placeholder="Código del Ambiente"
              v-model="ambiente.identifier"
              v-validate="modelValidations.identifier"
              name="identifier"
              :error="getError('identifier')"
            />
          </div>
        </div>
        <div class="text-right mt-3">
          <button
            type="submit"
            class="btn btn-filmker-pink btn-fill btn-sm"
          >
            Agregar Ambiente
          </button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </card>
</template>

<script>
import vueElementLoading from 'vue-element-loading'
import swal from 'sweetalert2'

export default {
  components: {
    vueElementLoading,
    swal
  },
  data() {
    return {
      loading: {
        text: 'Please Wait',
        color: '#222',
        active: false
      },
      ambiente: {
        name: '',
        identifier: ''
      },
      modelValidations: {
        name: { required: true },
        identifier: { required: true }
      }
    }
  },
  methods: {
    validate() {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.addAmbiente()
        }
      })
    },
    getError(fieldName) {
      return this.errors.first(fieldName)
    },
    addAmbiente() {
      this.loading.active = true
      this.axios({
        url: `conexions.php`,
        method: 'post',
        data: this.ambiente,
        headers: {
          authorization: localStorage.token
        }
      })
        .then(response => {
          this.loading.active = false
          this.showSwal('success', 'Ambiente creado')
          this.clearForm()
        })
    .catch(error => {
  this.loading.active = false
  this.showSwal(
    'error',
    (error.response && error.response.data && error.response.data.message) || 'Error en el servidor'
  )
})
    },
    showSwal(type, message) {
      swal.fire({
        title: message,
        icon: type
      })
    },
    clearForm() {
      this.ambiente = { name: '', identifier: '' }
    }
  }
}
</script>

<style>
  #edit_form label {
    color: #777 !important;
  }
</style>
